import ChidoMapIframe from "./ChidoMapIframe";

function Map() {
  return (
    <div>
      <ChidoMapIframe />
      {/* Other content */}
    </div>
  );
}

export default Map;
